import { AuthComponent } from '../../../app/app.types';
import { UserRole } from '../../user/user.model';


export interface CurrentMasterKeyTab extends AuthComponent {
  title: string;
  dataKey: string;
}

export const DashboardCurrentMasterKey : AuthComponent = {
  authorizedRoles: [
    UserRole.admin,
  ],
};

export const CurrentMasterKeyTabs: CurrentMasterKeyTab[] = [
  {
    title: 'High School',
    dataKey: 'highSchool',
    authorizedRoles: [
      UserRole.admin,
    ],
  },
  {
    title: 'Middle School / Jr. High',
    dataKey: 'middleSchool',
    authorizedRoles: [
      UserRole.admin,
    ],
  },
  {
    title: 'College Applications',
    dataKey: 'college',
    authorizedRoles: [
      UserRole.admin,
    ],
  },
];
